export default __webpack_public_path__ + "static/media/Montserrat-Bold.0915f0a8.ttf";